import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';
import Button from "components/button";
import Countdown from "components/countdown";
import moment from "moment";
import useMediaQuery from "hooks/useMediaQuery";

const REGISTER_DATA = DATA.register;

const Register = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');

    return (
        <section id='register-id' className="register-block container">
            <p className="title">{REGISTER_DATA.title}</p>
            <Countdown />
            <p className="pre-register">Đăng kí trước ngày {moment(DATA.deadline, 'DD/MM/YYYYTHH:mm:ss').format('DD/MM/YYYY')} </p>
            <div className="sub-title-wrapper">
                <p className="sub-title">{REGISTER_DATA.subTitle[0]}</p>
                {!isMobile ? <p className="sub-title">-</p> : ''}
                <p className="sub-title">{REGISTER_DATA.subTitle[1]}</p>
            </div>
            <Button href={DATA['form']} className="cta" content={REGISTER_DATA.cta}/>
        </section>
    )
}

export default Register